/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Nikolay Sviridov
 * @version 1.33.0
 * @since 1.33.0
 */

import { Fragment } from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';

import { Button } from '@components/common';
import { makeSelectTranslationWizardImportSubscribersLimits } from '@modules/internationalization/intSelectors';
import { IImportSubscribersLimitsExportModal, IWizardImportSubscribersLimitsTranslation } from '@modules/internationalization/types/wizards/importSubscribersLimits';
import { modalOpen } from '@modules/modal/modalActions';
import { IModalOpenPayload } from '@modules/modal/types/modalActionTypes';
import { IModalRenderProps } from '@modules/modal/types/modalTypes';
import { IWizardState } from '@modules/wizard/wizardReducer';
import { makeSelectWizardStepName } from '@modules/wizard/wizardSelectors';
import { IRootReducer } from '@reducers/rootReducer';

import { EWizardImportSubscribersLimitsSteps } from '../wizardImportSubscribersLimitsConstant';
import { IWizardImportSubscribersLimitsReducer } from '../wizardImportSubscribersLimitsReducer';
import { makeSelectWizardImportSubscribersLimitsErrorRowsAmount } from '../wizardImportSubscribersLimitsSelectors';
import WizardImportSubscribersLimitsExportModal from './WizardImportSubscribersLimitsExportModal/WizardImportSubscribersLimitsExportModal';


interface IWizardImportSubscribersLimitsTitleElementsProps {
    title: string;
}

const WizardImportSubscribersLimitsTitleElements = ({
    stepName,
    title,
    translation,
    openModal,
    errorRowsAmount,
}: IWizardImportSubscribersLimitsTitleElementsProps & IConnectedProps & IDispatchProps) => {

    const stepTranslation = translation[EWizardImportSubscribersLimitsSteps.ConfirmStep];
    const exportModalTranslation: IImportSubscribersLimitsExportModal = stepTranslation.exportModal;

    const exportErrorsHandler = () => {
        openModal({
            render: (props: IModalRenderProps) =>
                <WizardImportSubscribersLimitsExportModal
                    translation={exportModalTranslation}
                    onCloseModal={props.onCloseModal}
                />,
        });
    }

    return (
        <Fragment>
            {stepName === EWizardImportSubscribersLimitsSteps.ConfirmStep && !!errorRowsAmount && (
                <Button
                    className="button__button-content_export"
                    dataName="wizard-import-personal-data-open-export-error"
                    kind="small"
                    onClick={exportErrorsHandler}
                >
                    {title}
                </Button>
            )}
        </Fragment>
    );
};


interface IConnectedProps extends Pick<IWizardState, 'stepName'>, Pick<IWizardImportSubscribersLimitsReducer, 'errorRowsAmount'>{
    translation: IWizardImportSubscribersLimitsTranslation;
}

const mapStateToProps = createStructuredSelector<IRootReducer, IConnectedProps>({
    stepName: makeSelectWizardStepName(),
    errorRowsAmount: makeSelectWizardImportSubscribersLimitsErrorRowsAmount(),
    translation: makeSelectTranslationWizardImportSubscribersLimits(),
});

interface IDispatchProps {
    openModal: (payload: IModalOpenPayload) => void;
}

export const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
    openModal: (payload) => dispatch(modalOpen(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WizardImportSubscribersLimitsTitleElements);
